import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Advnture: Site = {
  id: 'advnture',
  logo: 'svg/advnture.svg',
  label: 'Advnture',
  analyticsName: 'advnture',
  hostname: 'advnture.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
